import axios from "axios";
import { Fragment, useEffect, useState } from "react";

import $ from "jquery";

import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

require("highcharts/modules/exporting")(Highcharts);
require("highcharts/modules/export-data")(Highcharts);

function Highchart2(props) {
    // console.log(props)
    const crtn = props.crtn;
    const infoCode = props.infoCode;
    const presentDate = new Date(crtn.date + ' ' + crtn.time);

    const [accData, setAccData] = useState({});
    const [pcpData, setPcpData] = useState({});
    const [sggNameArray, setSggNameArray] = useState([]);
    const [sggName, setSggName] = useState(null);               // 시군구 일때 시군구명

    const [chartTitle, setChartTitle] = useState(null);         // 차트 제목
    const [series, setSeries] = useState([]);                   // 차트 series data
     
    useEffect(() => {
        setSggName($('[element="gfas_Sit_select"] option:selected').text());

        axios.post(window.API_URL + '/Intro/getFallData', null, { params: { crtn: crtn.date + ' ' + crtn.time }})
        .then(results => {
            try {
                console.log(results.data);

                const acc = results.data.ACC;
                const nameArray = Object.keys(acc).sort();
                setSggNameArray(nameArray);

                for (let i = 0 ; i < nameArray.length; i ++) {
                    const sggArray = acc[nameArray[i]];
                    const conArray = [];
                    for (let j = 0 ; j < sggArray.length; j ++) {
                        const rowArray = sggArray[j];
                        const rowDate = new Date(rowArray[0]);
                        conArray.push([rowDate.getTime() + (9*3600000), rowArray[1]])

                    }
                    acc[nameArray[i]] = conArray;
                }
                setAccData(acc);

                const pcp = results.data.PCP;
                for (let i = 0 ; i < nameArray.length; i ++) {
                    const sggArray = pcp[nameArray[i]];
                    const conArray = [];
                    for (let j = 0 ; j < sggArray.length; j ++) {
                        const rowArray = sggArray[j];
                        const rowDate = new Date(rowArray[0]);
                        conArray.push([rowDate.getTime() + (9*3600000), rowArray[1]])
                    }
                    pcp[nameArray[i]] = conArray;
                }
                setPcpData(pcp);
            }
            catch(e) {
                console.log(e);
            }
        })
    }, [crtn, infoCode]);

    useEffect(() => {
        if(accData[sggName]) { 
            setSeries([
                { 
                    name: '예측 강우량', data: pcpData[sggName], 
                    tooltip: { valueSuffix: ' <span style=" color: #666; font-size: 9px; font-weight: normal; "> ㎜/<span>3hr</span></span>' }, 
                    type: 'bar', zIndex: 1 
                },
                { 
                    color: Highcharts.getOptions().colors[9], name: '누적 강우량', data: accData[sggName], 
                    tooltip: { valueSuffix: ' <span style=" color: #666; font-size: 9px; font-weight: normal; "> ㎜</span>' }, 
                    type: 'spline', yAxis: 1 
                },
            ])
        }
        setChartTitle('우량주상도 (' + sggName + ')');
    }, [accData, crtn, infoCode, pcpData, sggName, sggNameArray]);

    useEffect(() => {
        //console.log('This acc', accData);
    }, [accData]);

    useEffect(() => {
        // console.log('This pcp', pcpData);
    }, [pcpData]);

    useEffect(() => {
        // console.log('This SGG Name', sggNameArray);
    }, [sggNameArray]);

    Highcharts.setOptions({
        // colors: ['#2CAFFE', '#544FC5', '#00E272', '#FE6A35', '#6B8ABC', '#D568FB', '#2EE0CA', '#FA4B42', '#FEB56A', '#91E8E1'],
        // colors: ['#058DC7', '#50B432', '#ED561B', '#DDDF00', '#24CBE5', '#64E572', '#FF9655', '#FFF263', '#6AF9C4'],
        colors: ['#121212', '#544FC5', '#00E272', '#FE6A35', '#6B8ABC', '#D568FB', '#2EE0CA', '#FA4B42', '#FEB56A', '#C00000'],
        lang: {
            months: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
            shortMonths: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
            shortWeekdays: ['<span style="color: red;">일</span>', '월', '화', '수', '목', '금', '<span style="color: blue;">토</span>'],
            weekdays: ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일']
        }
    });

    const options = {
        chart: { 
            backgroundColor: 'transparent', height: 925, width: 1900 
        },
        credits: { enabled: false }, exporting: { enabled: true },
        legend: { verticalAlign: 'top' },
        plotOptions: { series: { marker: { enabled: false, radius: 0, states: { hover: { enabled: true  }}}}},
        series: series, subtitle: { text: new Date(crtn.date + ' ' + crtn.time).format('Y년 m월d일 H시 발표')},
        title: { margin: 20, y: 20, text: chartTitle },
        tooltip: { 
            crosshairs: true, dateTimeLabelFormats: { month: '\'%y년 %b월</b>', day: '%Y-%b-%d (%a)', hour: '<b style="fontSize: 12px">%Y-%b-%d (%a) %H:%M</b>' },
            headerFormat: '<table><tr><th colspan="2" style="border-bottom: 1px solid silver; height: 35px; text-align: left;">{point.key}</th></tr>',
            pointFormat: '<tr><td style="color: {series.color}; font-weight: bold;">{series.name} </td>' +
                         '<td style="text-align: right"><b>{point.y}</b></td></tr>',
            footerFormat: '</table>',
            shared: true, valueDecimals: 1, useHTML: true
        }, 
        xAxis: { 
            dateTimeLabelFormats: { 
                millisecond: '%H:%M:%S.%L', second: '%H:%M:%S', minute: '%H:%M', hour: '%H:%M', 
                day: '<b">%b/%d</b> (%a)', week: '\'%y %b %d', month: '\'%y %b', year: '%Y' 
            },
            plotLines: [{
                color: '#59D',  dashStyle: 'shortDash', label: { align: 'left', text: '발표시간', x: 10 },
                value: presentDate.getTime() - presentDate.getTimezoneOffset() * 60000, width: 1
            }],
            title: { style: { fontSize: '15px' }, text: '일시' },
            type: 'datetime' 
        },
        yAxis: [{
            labels: { style: { color: Highcharts.getOptions().colors[0]  } },
            title: { style: { color: Highcharts.getOptions().colors[0], fontSize: '15px' }, text: '예측 강우량 (㎜/3hr)' }
        }]
    }

    options.plotOptions = {
        areaspline: {
            fillColor: {
                linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                stops: [
                    [0, Highcharts.getOptions().colors[9]],
                    [1, Highcharts.color(Highcharts.getOptions().colors[9]).setOpacity(0).get('rgba')]
                ]
            },
            lineWidth: 2, marker: { radius: 0 }, states: { hover: { lineWidth: 1 }}, threshold: null
        },
        spline: { marker: { radius: 3 }}
    }
    
    options.yAxis[1] = {
        labels: { style: { color: Highcharts.getOptions().colors[9]  } },
        title: { style: { color: Highcharts.getOptions().colors[9], fontSize: '15px' }, text: '누적 강우량 (㎜)' }, opposite: true
    }

    // console.log(options)
    return (<>{ 
        <Fragment>
            <HighchartsReact highcharts={ Highcharts } options={ options } />
        </Fragment>
    }</>)
}

export default Highchart2;